import { render, staticRenderFns } from "./AlternativeSidebar.vue?vue&type=template&id=03f182b4&"
import script from "./AlternativeSidebar.vue?vue&type=script&lang=js&"
export * from "./AlternativeSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports